function getInfiniteQueryCurrentDataLength(data) {
    return ((data === null || data === void 0 ? void 0 : data.pages.reduce((counter, page) => {
        return counter + page.results.length;
    }, 0)) || 0);
}

export { getInfiniteQueryCurrentDataLength };
//# sourceMappingURL=getInfiniteQueryCurrentDataLength.js.map
